import React from "react";
import CustomSpin from "../Spins/CustomSpin";

const FullPageLoader = () => {
  return (
    <div className="fixed flex justify-center items-center left-0 top-0 w-full h-full bg-white/70">
      <CustomSpin />
    </div>
  );
};

export default FullPageLoader;
